module.exports = __webpack_public_path__ + "static/media/calendar.470f1951.svg";